<template>
    <div class="codics-lottery-hxjp-body">
        <div class="codics-lottery-hxjp-card">
            <div class="codics-lottery-hxjp-img-box">
                <el-image class="codics-lottery-hxjp-img"
                    :src="recordData == null ? '' : ('https://cdn.bosscaigou.com' + recordData.lottery.img)"
                    fit="fill"></el-image>
                <div class="codics-lottery-hxjp-name">{{ recordData == null ? '未知奖品' : recordData.lottery.name }}</div>
                <div class="codics-lottery-hxjp-tag"
                    :style="{ '--fontColor': (recordData == null || recordData.state == 0) ? '#E0E0E0' : '#f56c6c' }">{{
                        (recordData == null || recordData.state == 0) ? '未核销'
                            : '已核销' }}</div>
                <div class="codics-lottery-hxjp-count">x1</div>
            </div>
            <el-steps class="codics-lottery-hxjp-step" :active="activeNum" finish-status="success" align-center>
                <el-step title="抽奖"></el-step>
                <el-step title="核销"></el-step>
                <el-step title="完成"></el-step>
            </el-steps>
            <div class="codics-lottery-hxjp-tip">
                提示：请仔细核对奖品与出库奖品是否一致<br>
                确认中奖人员与奖品无误之后点击下方核销按钮完成核销操作
            </div>
        </div>
        <div class="codics-lottery-hxjp-btn" @click="hexRecordFuc"
            :style="{ '--bckColor': (recordData == null || recordData.state == 0) ? '#6431B6' : '#C0C0C0' }">{{
                        (recordData == null || recordData.state
                            == 0) ? '立即核销'
                            : '已核销' }}</div>
    </div>
</template>

<script>
import { infoRecord, hexRecord2 } from '@/api';
import { getCookie } from '@/utils/mycookie';
import { jumpTo } from '@/utils/myutils';
export default {
    data() {
        return {
            recordData: null,
            jpImg: 'https://cdn.bosscaigou.com/huayuan/img/%E7%A2%97%E6%B4%97%E6%B4%81%E7%B2%BE.svg',
            activeNum: 1
        }
    },
    mounted() {
        if (getCookie('user-inf') == null) {
            jumpTo(this, '后台登录', { path: window.location.href }, {});
            return;
        }
        this.infoRecordFuc();
    },
    methods: {
        async infoRecordFuc() {

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await infoRecord({ id: this.$route.params.id, code: this.$route.query.code, rid: this.$route.query.j, name: this.$route.query.name, phone: this.$route.query.phone });

            loading.close();

            if (data.code == 200) {

                this.recordData = data.data;

                this.activeNum = this.recordData.state == 0 ? 1 : 3;

            } else {

                this.$message.error(data.message);

            }

        },
        async hexRecordFuc() {

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await hexRecord2({ id: this.$route.params.id, code: this.$route.query.code, rid: this.$route.query.j });

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: '订单核销成功',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);

            } else {

                this.$message.error(data.message);

            }
        }
    }
}
</script>

<style>
.codics-lottery-hxjp-body {
    height: 100%;
    width: 100%;
    position: relative;
    float: left;
    overflow: hidden;
    box-sizing: border-box;
    background: #FFF;
}

.codics-lottery-hxjp-body::before {
    content: '';
    height: 200vh;
    width: 200vh;
    position: absolute;
    margin: auto;
    left: 50%;
    top: -180vh;
    transform: translateX(-50%);
    background: #6431B6;
    border-radius: 100vh;
}

.codics-lottery-hxjp-card {
    height: fit-content;
    width: calc(100% - 30px);
    position: relative;
    float: left;
    border-radius: 5px;
    margin-top: 70px;
    background: #FFF;
    left: 50%;
    transform: translateX(-50%);
    box-shadow: 0 0 5px rgba(0, 0, 0, .2);
    box-sizing: border-box;
    padding: 0 15px;
}

.codics-lottery-hxjp-btn {
    height: 45px;
    width: 100%;
    position: fixed;
    bottom: 0;
    line-height: 45px;
    text-align: center;
    font-size: 13px;
    color: #FFF;
    background: #6431B6;
}

.codics-lottery-hxjp-img-box {
    height: 100px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    border-bottom: 1px solid #f0f0f0;
}

.codics-lottery-hxjp-img {
    height: 100px;
    width: 70px;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 15px;
}

.codics-lottery-hxjp-step {
    height: 100px;
    width: 100%;
    position: relative;
    float: left;
    margin-top: 40px;
    left: 50%;
    transform: translateX(-50%);
}

.codics-lottery-hxjp-tip {
    height: 100px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    line-height: 2;
    font-size: 13px;
    text-align: center;
    color: #c0c0c0;
    margin-top: 0px;
    box-sizing: border-box;
    padding: 0 30px;
}

.codics-lottery-hxjp-name {
    height: 50px;
    width: calc(100% - 85px);
    position: relative;
    float: left;
    line-height: 50px;
    font-size: 14px;
    color: #333;
    margin-left: 15px;
    margin-top: 5px;
}

.codics-lottery-hxjp-tag {
    height: 20px;
    width: fit-content;
    position: relative;
    float: left;
    line-height: 20px;
    text-align: center;
    font-size: 11px;
    color: #888;
    background: var(--fontColor);
    padding: 0 8px;
    margin-left: 15px;
    border-radius: 10px;
}

.codics-lottery-hxjp-count {
    height: 100px;
    width: 50px;
    position: absolute;
    margin: auto;
    top: 0;
    right: 0;
    text-align: center;
    line-height: 100px;
    font-size: 25px;
    color: #6431B6;
    font-weight: bolder;
}
</style>